import React, { useEffect, useState } from 'react';
import { DataGrid, GridColumns } from '@mui/x-data-grid';
import { EftStatementHelper } from '../../../../helpers/EftStatementHelper';
import { NavLink } from 'react-router-dom';
import { GetEftStatementResponse } from '../../../../models/EftStatement';
import { PaymentsEftRecordStatus, PaymentsEftRecordType, PaymentsEftStatementStatus } from '../../../../models/DeprecatedEnums';
import { useParams } from 'react-router';
import ErrorComponent from '../../../components/shared/ErrorComponent';
import { GeneralHelper } from '../../../../helpers/GeneralHelper';
import { Badge, Button, Menu, MenuItem, Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import LoadingComponent from '../../../components/shared/LoadingComponent';
import LinkMemberComponent from '../../../components/payments/LinkMemberComponent';
import RecordDetailsComponent from '../../../components/payments/RecordDetailsComponent';
import ChangeEftRecordStatusComponent from '../../../components/payments/ChangeEftRecordStatusComponent';
import ChangeEftRecordTypeComponent from '../../../components/payments/ChangeEftRecordTypeComponent';
import Chip from '@mui/material/Chip';

const StatementPage = (props: any) => {
  console.log('Entered StatementPage...', props);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isProcessing, toggleProcessingState] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [snackbarNotification, showSnackbarNotification] = useState<any>({
    open: false,
    severity: 'success',
    message: 'Message...'
  });
  const [statementInfo, setStatementInfo] = useState<GetEftStatementResponse>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isLinkMemberDialogOpen, toggleLinkMemberDialog] = useState<boolean>(false);
  const [isRecordDetailsDialogOpen, toggleRecordDetailsDialog] = useState<boolean>(false);
  const [isChangeStatusDialogOpen, toggleChangeStatusDialog] = useState<boolean>(false);
  const [isChangeTypeDialog, toggleChangeTypeDialog] = useState<boolean>(false);
  const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
  const [eftCount, setEftCount] = useState<any | 0>(0);
  const [feeCount, setFeeCount] = useState<any | 0>(0);
  const [swiftCount, setSwiftCount] = useState<any | 0>(0);
  const [cashCount, setCashCount] = useState<any | 0>(0);
  const [otherCount, setOtherCount] = useState<any | 0>(0);
  const [pendingRecordsCount, setPendingRecordCount] = useState<any | 0>(0);
  // const [members, setMembers] = useState<Member[]>([]);
  const [members, setMembers] = useState<any[]>([]);

  const open = Boolean(anchorEl);
  const params: any = useParams();
  const statementId: number = params.statementId;

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleNotificationClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    showSnackbarNotification({ open: false });
  };

  /* 828
  const loadEftStatementInfo = async () => {
    try {
      setIsLoading(true);
      const response: GetEftStatementResponse = await EftService.getStatementDetails(Number(statementId));
      loadStatementDetails(response);
    } catch (err) {
      showSnackbarNotification({ open: true, severity: 'error', message: err.message });
      setError(err.message);
      setIsLoading(false);
    }
  };

   */

  const loadStatementDetails = (response: GetEftStatementResponse): void => {
    setIsLoaded(true);
    setStatementInfo(response);
    setIsLoading(false);
    toggleProcessingState(false);

    const eftCounter = response.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.EFT).length;
    const feeCounter = response.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.FEE).length;
    const swiftCounter = response.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.SWIFT).length;
    const cashCounter = response.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.CASH).length;
    const otherCounter = response.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.OTHER).length;
    const pendingCounter = response.eftRecords.filter(function(record) {
      return record.status === PaymentsEftRecordStatus.PENDING.toString() || record.status === PaymentsEftRecordStatus.IGNORE.toString();
    }).length;

    setEftCount(eftCounter);
    setFeeCount(feeCounter);
    setSwiftCount(swiftCounter);
    setCashCount(cashCounter);
    setOtherCount(otherCounter);
    setPendingRecordCount(pendingCounter);
  };

  /* 828
  useEffect(() => {
    if (!isLoading && !isLoaded && !error) {
      loadEftStatementInfo();
    }
  }, [isLoaded, isLoading, error]);
   */

  const updateSelectedRecord = (record: any): void => {
    if (selectedRecord && record && selectedRecord.id === record.id) {
      selectedRecord.memberWalletAddressId = record.memberWalletAddressId;
      selectedRecord.memberId = record.memberId;
      selectedRecord.memberName = record.memberName;
      selectedRecord.memberEmail = record.memberEmail;
      selectedRecord.popReceivedName = record.popReceivedName;
      selectedRecord.popReceivedEmail = record.popReceivedEmail;
      selectedRecord.referenceUsed = record.referenceUsed;
      selectedRecord.amount = record.amount;
      selectedRecord.transactionDate = record.transactionDate;
      selectedRecord.resolution = record.resolution;
      selectedRecord.popReceived = record.popReceived;
      selectedRecord.popReceivedAt = record.popReceivedAt;
      selectedRecord.popReceivedBy = record.popReceivedBy;
      selectedRecord.originalRecord = record.originalRecord;
      selectedRecord.originalDescription1 = record.originalDescription1;
      selectedRecord.originalDescription2 = record.originalDescription2;
      selectedRecord.status = record.status;
      selectedRecord.recordType = record.recordType;
      selectedRecord.linkedFeeId = record.linkedFeeId;
      selectedRecord.promixaResponse = record.promixaResponse;
      selectedRecord.processedAt = record.processedAt;
      setSelectedRecord(selectedRecord);
      // setRecordSaved(true);
    } else {
      setSelectedRecord(record);
      // setRecordSaved(false);
    }

    if (statementInfo) {
      const eftCounter = statementInfo.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.EFT).length;
      const feeCounter = statementInfo.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.FEE).length;
      const swiftCounter = statementInfo.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.SWIFT).length;
      const cashCounter = statementInfo.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.CASH).length;
      const otherCounter = statementInfo.eftRecords.filter(record => record.recordType === PaymentsEftRecordType.OTHER).length;
      const pendingCounter = statementInfo.eftRecords.filter(function(record) {
        return record.status === PaymentsEftRecordStatus.PENDING.toString() || record.status === PaymentsEftRecordStatus.IGNORE.toString();
      }).length;

      setEftCount(eftCounter);
      setFeeCount(feeCounter);
      setSwiftCount(swiftCounter);
      setCashCount(cashCounter);
      setPendingRecordCount(pendingCounter);
      setOtherCount(otherCounter);
    }
  };

  const linkSelectedMember = async (member: any): Promise<void> => {
    return
    /* 828
    if (!selectedRecord || !member) return;

    const response: GetEftRecordResponse = await EftService.linkMember(selectedRecord.id, member.id);
    if (response.record) {
      updateSelectedRecord(response.record);
      showSnackbarNotification({ open: true, message: 'Member linked to record.' });
    }
    toggleLinkMemberDialog(false);
    setMembers([]);
    closeRecordContextMenu();
     */
  };

  const updateRecordType = async (recordType: PaymentsEftRecordType): Promise<void> => {
    return
    /* 828
    if (!selectedRecord || !selectedRecord.id || !recordType) return;
    const response: GetEftRecordResponse = await EftService.changeRecordType(selectedRecord.id, recordType);
    if (response.record) {
      updateSelectedRecord(response.record);
      showSnackbarNotification({ open: true, message: 'Record type updated.' });
    }
    toggleChangeTypeDialog(false);
    closeRecordContextMenu();

     */
  };

  const updateRecordStatus = async (status: PaymentsEftRecordStatus): Promise<void> => {
    return;
    /* 828
    if (!selectedRecord || !selectedRecord.id || !status) return;
    const response: GetEftRecordResponse = await EftService.changeRecordStatus(selectedRecord.id, status);
    if (response.record) {
      updateSelectedRecord(response.record);
      showSnackbarNotification({ open: true, message: 'Record status updated.' });
    }
    toggleChangeStatusDialog(false);
    closeRecordContextMenu();

     */
  };

  const markRecordPopReceived = async (): Promise<void> => {
    return;
    /* 828
    if (!selectedRecord) return;
    const response: GetEftRecordResponse = await EftService.markPopAsReceived(selectedRecord.id);

    if (response.record) {
      updateSelectedRecord(response.record);
      showSnackbarNotification({ open: true, severity: 'info', message: 'POP Received.' });
    }
    closeRecordContextMenu();

     */
  };

  const handleMemberSearch = async (queryString: string) => {
    /* 828
    const memberResults = await MemberService.searchMembersWalletsOrders(queryString);
    setMembers(memberResults);
     */
  };

  const openStatusDialog = async (record: any): Promise<void> => {
    setSelectedRecord(record);
    if (
      record.status === PaymentsEftRecordStatus.PENDING ||
      record.status === PaymentsEftRecordStatus.IGNORE ||
      record.status === PaymentsEftRecordStatus.DUPLICATE
    ) {
      toggleChangeStatusDialog(true);
    } else if (record.status === PaymentsEftRecordStatus.ERROR) {
      showSnackbarNotification({ open: true, severity: 'error', message: record.promixaResponse });
    }
  };

  const openTypeDialog = async (record: any): Promise<void> => {
    setSelectedRecord(record);
    toggleChangeTypeDialog(true);
  };

  const recordReferenceClick = async (reference: string): Promise<void> => {
    if (reference) {
      await navigator.clipboard.writeText(reference);
      showSnackbarNotification({ open: true, severity: 'info', message: 'Referenced copied' });
    }
  };

  const openRecordContextMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const closeRecordContextMenu = (): void => {
    setAnchorEl(null);
    setSelectedRecord(null);
  };

  const recordColumns: GridColumns = EftStatementHelper.getEftStatementColumns(
    openRecordContextMenu,
    updateSelectedRecord,
    openStatusDialog,
    openTypeDialog,
    recordReferenceClick
  );
  const memberColumns: GridColumns = EftStatementHelper.getMemberLinkColumns(linkSelectedMember);

  const processStatement = async (): Promise<void> => {
    return
    /* 828
    toggleProcessingState(true);
    const response: GetEftStatementResponse = await EftService.finalizeEfts(Number(statementId));
    loadStatementDetails(response);
     */
  };

  const processIgnoreRecord = async (): Promise<void> => {
    return
    /* 828
    if (!selectedRecord || !selectedRecord.id) return;
    console.log('processIgnoreRecord HIT!');
    const response: GetEftRecordResponse = await EftService.changeRecordStatus(selectedRecord.id, PaymentsEftRecordStatus.IGNORE);
    if (response.record) {
      updateSelectedRecord(response.record);
    }
    toggleChangeStatusDialog(false);
    closeRecordContextMenu();
     */
  };

  return (
    <React.Fragment>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarNotification.open}
        autoHideDuration={6000}
        onClose={handleNotificationClose}
      >
        <Alert onClose={handleNotificationClose} severity={snackbarNotification.severity} sx={{ width: '100%' }}>
          {snackbarNotification.message}
        </Alert>
      </Snackbar>
      <Grid container>
        <Grid item lg={12}>
          <Paper>
            <Box sx={{ p: 4, mt: 3 }}>
              {isLoading && <LoadingComponent />}
              {error && <ErrorComponent message={error} />}
              {isLoaded && statementInfo && (
                <React.Fragment>
                  <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                      <Typography variant={'h6'}>Statement Information</Typography>
                    </Grid>
                    <Grid item>
                      <NavLink to={'/app/finance-area/statements'} className="btn btn-outline-light bg-white d-none d-sm-inline-flex">
                        <em className="icon ni ni-arrow-left" />
                        <span>Back</span>
                      </NavLink>
                      <NavLink to={'/app/finance-area/statements'} className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none">
                        <em className="icon ni ni-arrow-left" />
                      </NavLink>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Statement Date</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{GeneralHelper.formatDate(statementInfo.eftStatement.statementDate.toString())}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>File name</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{statementInfo.eftStatement.statementFilename}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Opening Balance</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{GeneralHelper.formatCurrency(statementInfo.eftStatement.openingBalance)}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Closing Balance</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{GeneralHelper.formatCurrency(statementInfo.eftStatement.closingBalance)}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Raw number of lines</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{statementInfo.eftStatement.rawNumberLines}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Records</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{statementInfo.eftStatement.recordCount}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Status</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{statementInfo.eftStatement.status}</strong>
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography variant={'body2'}>Uploaded by</Typography>
                      <Typography variant={'subtitle1'}>
                        <strong>{statementInfo.eftStatement.createdBy}</strong>
                      </Typography>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={12}>
          <Paper>
            <Box sx={{ p: 4, mt: 3 }}>
              {isLoaded && statementInfo && (
                <React.Fragment>
                  The list of records associated to the EFT statement
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item md={1}>
                      <Badge badgeContent={eftCount} color="primary">
                        <Chip label={'EFT'} variant="outlined" color="primary" />
                      </Badge>
                    </Grid>
                    <Grid item md={1}>
                      <Badge badgeContent={swiftCount} color="secondary">
                        <Chip label={'Swift'} variant="outlined" color="secondary" />
                      </Badge>
                    </Grid>
                    <Grid item md={1}>
                      <Badge badgeContent={cashCount} color="success">
                        <Chip label={'Cash'} variant="outlined" color="success" />
                      </Badge>
                    </Grid>
                    <Grid item md={1}>
                      <Badge badgeContent={feeCount} color="error">
                        <Chip label={'Fee'} variant="outlined" color="error" />
                      </Badge>
                    </Grid>
                    <Grid item md={1}>
                      <Badge badgeContent={otherCount} color="warning">
                        <Chip label={'Other'} variant="outlined" />
                      </Badge>
                    </Grid>
                    <Grid item md={2}>
                      {(statementInfo.eftStatement.status === PaymentsEftStatementStatus.INITIATED ||
                        statementInfo.eftStatement.status === PaymentsEftStatementStatus.IN_PROGRESS) && (
                        <Badge badgeContent={pendingRecordsCount} color="primary">
                          <Button variant="contained" color="primary" onClick={processStatement} disabled={isProcessing}>
                            Process records
                          </Button>
                        </Badge>
                      )}
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={12}>
          <Paper>
            <Box>
              {isLoaded && statementInfo && (
                <div style={{ height: 500 }}>
                  <DataGrid rows={statementInfo.eftRecords} loading={isProcessing} columns={recordColumns} components={{}} />
                </div>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Menu anchorEl={anchorEl} open={open} onClose={closeRecordContextMenu}>
        <MenuItem onClick={() => toggleRecordDetailsDialog(true)}>View Detail</MenuItem>
        <MenuItem
          disabled={
            !(
              selectedRecord !== null &&
              (selectedRecord.status === PaymentsEftRecordStatus.PENDING || selectedRecord.status === PaymentsEftRecordStatus.IGNORE)
            )
          }
          onClick={() => toggleLinkMemberDialog(true)}
        >
          Link Member
        </MenuItem>
        <MenuItem
          disabled={
            !(
              selectedRecord !== null &&
              (selectedRecord.status === PaymentsEftRecordStatus.PENDING || selectedRecord.status === PaymentsEftRecordStatus.IGNORE)
            )
          }
          onClick={() => markRecordPopReceived()}
        >
          Mark Proof of Payment Received
        </MenuItem>
        <MenuItem
          disabled={
            !(
              selectedRecord !== null &&
              (selectedRecord.status === PaymentsEftRecordStatus.PENDING || selectedRecord.status === PaymentsEftRecordStatus.IGNORE)
            )
          }
          onClick={processIgnoreRecord}
        >
          Ignore
        </MenuItem>
        <MenuItem
          disabled={
            !(
              selectedRecord !== null &&
              (selectedRecord.status === PaymentsEftRecordStatus.PENDING || selectedRecord.status === PaymentsEftRecordStatus.IGNORE)
            )
          }
        >
          Mark as duplicate
        </MenuItem>
      </Menu>

      {selectedRecord !== null && (
        <React.Fragment>
          <LinkMemberComponent
            show={isLinkMemberDialogOpen}
            toggleDialog={toggleLinkMemberDialog}
            columns={memberColumns}
            handleMemberSearch={handleMemberSearch}
            members={members}
          />
          <RecordDetailsComponent
            selectedRecord={selectedRecord}
            show={isRecordDetailsDialogOpen}
            toggleDialog={toggleRecordDetailsDialog}
          />
          <ChangeEftRecordStatusComponent
            selectedRecord={selectedRecord}
            updateRecordStatus={updateRecordStatus}
            toggleDialog={toggleChangeStatusDialog}
            show={isChangeStatusDialogOpen}
          />
          <ChangeEftRecordTypeComponent
            selectedRecord={selectedRecord}
            updateRecordType={updateRecordType}
            toggleDialog={toggleChangeTypeDialog}
            show={isChangeTypeDialog}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default StatementPage;
